const ANNUAL_FREQUENCIES = new Set(['annual', 'annually', 'yearly']);
const ANNUAL_PLAN_CODE = /annual/i;

export const isAnnualBillingFrequency = (billingFrequency?: string | null): boolean =>
  ANNUAL_FREQUENCIES.has((billingFrequency || '').toLowerCase());

// Subscriptions and product terms both express an annual period as ANNUALLY (or ANNUAL/YEARLY in some sources)
export const isAnnually = (value?: string | null): boolean => isAnnualBillingFrequency(value);

/*
  Flex plans expose their periodicity as a term (products API) but the entitlements API only returns a plan code,
  so we fall back to the plan code naming convention (id-annual, id-annual-free) when no term is available.
*/
const resolveFlexBillingFrequency = ({
  term,
  planCode,
}: {
  term?: string | null;
  planCode?: string | null;
}): string | null => {
  if (term) {
    return isAnnualBillingFrequency(term) ? 'annual' : 'monthly';
  }

  if (planCode) {
    return ANNUAL_PLAN_CODE.test(planCode) ? 'annual' : 'monthly';
  }

  return null;
};

export default resolveFlexBillingFrequency;
